<script>
export default {
	props: {
		active: Boolean,
	},
}
</script>

<template>
	<div class="thumb-img rounded" :class="{ 'thumb-img--active': active }">
		<Media class="rounded" v-on="$listeners" v-bind="$attrs" aspect-ratio="1" />
	</div>
</template>

<style scoped>
.thumb-img {
	cursor: pointer;
	border: 1px solid #aaa;
	padding: 3px;
}
.thumb-img--active {
	border: 2px solid #333;
	padding: 2px;
}
</style>
